import React from 'react';
import PageLayout from '../../layout/PageLayout';
import SelectionOfSuppliers from '../../layout/SelectionOfSuppliers';

const SelectionOfSuppliersPage: React.FC = () => (
  <PageLayout>
    <SelectionOfSuppliers />
  </PageLayout>
);

export default SelectionOfSuppliersPage;
